import React,{useEffect, useState} from 'react';
import { Grid,Button, IconButton, Tooltip } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import NumericLabel from 'react-pretty-numbers';
import {assetType, assetTypeLabel, backendDateFormat, displayDateFormatShort, fieldDateFormat, prettyNumberParamsDB,} from '../../../constants';
import { globalGetService, globalPostService, globalPutService } from '../../../utils/globalApiServices';
import { checkApiStatus, checkPermission, getLocalStorageInfo } from '../../../utils';
import appConfig from '../../../config';
import { PageLoader } from '../../../shared_elements';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { useSnackbar } from 'notistack';

const ShopVisitTitle = ({event, assemblyType, goBack, getResponseBack}) => {
  let userInfo = getLocalStorageInfo();
  const { enqueueSnackbar } = useSnackbar();
  const [assemblyCardData,setAssemblyCardData] = useState()
  const [loading,setLoading] = useState()
  const [isEditing, setIsEditing] = useState(false);
  const [newDate, setNewDate] = useState(event?.as_of_date ? moment(event?.as_of_date): event.shop_visit_date ? moment(event?.shop_visit_date) : null);
  const [dateError, setDateError] = useState('');

  useEffect(() => {
    setLoading(true)
    if(event?.asset_slug){
      globalGetService(`/maintenance/asset-type/${assemblyType}/asset/${event?.asset_slug}/shopvisit/${event?.id}/cashflow-card/`)
      .then(response => {
        if (checkApiStatus(response)) {
          setLoading(false)
          setAssemblyCardData(response?.data?.data)
        }
      })
    }
  }, [event?.asset_slug,assemblyType])
  const editAsOfDate = () => {
    if (newDate && !moment(newDate).isValid()) {
      setDateError('Enter valid As of Date');
      return;
    }
    if (!newDate || newDate ==='Invalid date') {
      setDateError('Enter As of Date');
      return;
    }
    globalPutService(`maintenance/asset-type/${assetType[event?.asset_type]}/asset/${event?.asset_slug}/shopvisit/${event?.id}/cashflow-card/`, { 'as_of_date': newDate ? moment(newDate).format(backendDateFormat) : moment(event.as_of_date).format(backendDateFormat) })
      .then(response => {
        if (checkApiStatus(response)) {
          setIsEditing(false);
          getResponseBack()
          enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        } else {
          enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        }
      })
  }
  return (
    <> <Grid container spacing={0} className='title-info'>
    <Grid xs={8} >
      <ArrowBackIcon color="primary" className="arrow-icon" onClick={goBack}/>
      <h4>{event.name}
         {event?.is_grouped ?
          <div style={{ padding: "1px 7px", marginLeft: '5px' }} className="grouped-lg">Grouped LG</div>
          : null}
      </h4>
      <p style={isMobile ? {fontSize:"12px"} : {}}>{assemblyType=='airframe'? 'Event': 'Shop Visit'} Date : {moment(event.shop_visit_date).format(displayDateFormatShort)} </p>
      {event?.asset_slug &&event?.contract_id ?  <Grid className='redirect-button-div'>
        {checkPermission('contracts', 'qualified_maintenance_event', 'R') ? <Button color="primary" variant="outlined" className='mr-8'
          onClick={() => {
            if (checkPermission('contracts', 'qualified_maintenance_event', 'R') ) {
               window.open(`${appConfig.domain.lease}${assemblyType === "airframe" ? "aircraft" : assemblyType}/${event?.asset_slug}/contract/${event?.contract_id}/qualified-maintenance`)
            }
          }
          }
        >
         Qualified maintenance events
        </Button> : null}

        {userInfo?.user?.permission?.contracts && Object.keys(userInfo?.user?.permission?.contracts)?.length ?<Button  color="primary" variant="outlined" 
         onClick={() => {
          if (userInfo?.user?.permission?.contracts && Object.keys(userInfo?.user?.permission?.contracts)?.length && event?.asset_slug &&event?.contract_id ) {
             window.open(`${appConfig.domain.lease}${assemblyType === "airframe" ? "aircraft" : assemblyType}/${event?.asset_slug}/contract/list/${event?.contract_id}`)
          }
        }
        }
        >
          Lease Agreement details
        </Button> : null }
        
        </Grid> : null}
    </Grid>
      <Grid  xs={4} className='justify-content-end'> <div style={{ display: 'flex' }}>
        <div style={{marginRight:"12px"}}> <div className='fund-title'>Fund Balance </div>
          <div className='fund-date-title'>As of Date</div>
          <div className="fund-date verify-amount-modal assign-user-modal" style={{ display: "flex", alignItems: "center" }}>
                {!isEditing ? (
                  <>
                    <Tooltip title={'Edit As of Date'} ><EditIcon fontSize='small' color='primary' style={{ cursor: 'pointer', marginRight: 6 }} onClick={() => {setIsEditing(true);setNewDate(event?.as_of_date ? moment(event.as_of_date) :event.shop_visit_date ? moment(event?.shop_visit_date): null)}}/></Tooltip>
                    ({event?.as_of_date ? moment(event?.as_of_date).format(displayDateFormatShort) : event.shop_visit_date ?moment(event?.shop_visit_date).format(displayDateFormatShort):""})
                  </>
                ) : (
                  <>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                        autoOk
                        margin="normal"
                        format={fieldDateFormat}
                        value={ newDate ? moment(newDate) : null }                        
                        onChange={(date) => {setNewDate(date);setDateError('')}}
                        inputVariant="outlined"
                        error={!!dateError} 
                        helperText={dateError}
                        FormHelperTextProps={{ style: { color: 'red' } }}
                        style={{ width: "200px", margin: "0px 8px 0px 0px" }}
                      />
                    </MuiPickersUtilsProvider>
                    <Tooltip title={'SAVE'}><IconButton size="small" color="primary" onClick={editAsOfDate}><CheckIcon style={{marginBottom:dateError?'30px':''}} fontSize="small" /></IconButton></Tooltip>
                    <Tooltip title={'CANCEL'} ><IconButton size="small" color="secondary" onClick={() => {setIsEditing(false);setDateError('')}}> <CloseIcon style={{marginBottom:dateError?'30px':''}} fontSize="small" /></IconButton></Tooltip>
                  </>
                )}
              </div>
              </div>
             <div className="reserve-account-card">
              <h3 >{assemblyType && assetTypeLabel[assemblyType]?.label}</h3>
               {assemblyType =='engine' ? <div style={{display:"flex"}}>
                 <div style={{marginRight :"18px"}}>
                <h5>PRSV</h5>
                <p>
                  <NumericLabel params={prettyNumberParamsDB}>{assemblyCardData?.prsv_total ? assemblyCardData?.prsv_total : 0}</NumericLabel>
                </p>
              </div>
              <div>
                <h5>LLP Replacement</h5>
                <p>
                  <NumericLabel params={prettyNumberParamsDB}>{assemblyCardData?.llp_total ? assemblyCardData?.llp_total : 0}</NumericLabel>
                </p>
              </div></div> : <div>
                <h5>Fund Balance</h5>
                <p>
                  <NumericLabel params={prettyNumberParamsDB}>{assemblyCardData?.amount ? assemblyCardData?.amount :0}</NumericLabel>
                </p>
              </div> }
             
            {/* </div> */}
        </div></div></Grid>
  </Grid>
  {loading ? <PageLoader /> :null}
  
  </>
   
  )
}
export default ShopVisitTitle;
